export const YOUR_SERVICE_ID = "service_zxv2t8b";
export const YOUR_TEMPLATE_ID = "template_ga9w40v";
export const YOUR_PUBLIC_KEY = "2Y9EOoUIz2kj-lK6b";
